var exports = {
  "Q": "content__cw9d2I",
};

module.exports = exports;
